import { render } from "./IFb.vue?vue&type=template&id=1d5fec7d"
import script from "./IFb.vue?vue&type=script&lang=js"
export * from "./IFb.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__